import styled from "styled-components";

export const CMSpotify = styled.h4(props => ({
    display: 'flex',
    alignItems: 'center',
    fontWeight: 500,
    marginTop: '40px !important',
    color: `${props.theme.palette.dark['900']} !important`,

    '& svg': {
        width: '32px',
        height: '32px',
        marginRight: props.theme.spacers["3"],
    },
    '& a': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration:'unset',
        color: `${props.theme.palette.dark['900']} !important`,
        fontFamily: props.theme.fontFamilies.workSans,

        '&:hover': {
            textDecoration: 'underline'
        }
    }
}));